import { P5CanvasInstance } from '@p5-wrapper/react';
import { Color } from 'p5';

export enum Direction {
  DIAG_UP_LEFT = 0,
  DIAG_UP_RIGHT = 2,
  DIAG_DOWN_LEFT = 5,
  DIAG_DOWN_RIGHT = 7,
  UP = 1,
  LEFT = 3,
  RIGHT = 4,
  DOWN = 6,
};

export class Walker {
  p5: P5CanvasInstance;
  x: number;
  y: number;
  width: number;
  height: number;
  color: Color;

  constructor(p5: P5CanvasInstance, color?: Color) {
    const defaultColor = p5.color(0);
    this.p5 = p5;
    this.x = p5.width / 2;
    this.y = p5.height / 2;
    this.width = p5.width;
    this.height = p5.height;
    this.color = color ?? defaultColor;
  }

  show() {
    this.p5.stroke(this.color);
    this.p5.point(this.x, this.y,);
  }

  step(direction?: Direction) {
    const choice: Direction = direction ?? this.p5.floor(this.p5.random(8)) as unknown as Direction;

    switch (choice) {
      case Direction.DIAG_UP_LEFT:
        this.x--;
        this.y--;
        break;
      case Direction.UP:
        this.y--;
        break;
      case Direction.DIAG_UP_RIGHT:
        this.x++;
        this.y--;
        break;
      case Direction.LEFT:
        this.x--;
        break;
      case Direction.RIGHT:
        this.x++;
        break;
      case Direction.DIAG_DOWN_LEFT:
        this.x--;
        this.y++;
        break;
      case Direction.DOWN:
        this.y++;
        break;
      case Direction.DIAG_DOWN_RIGHT:
        this.x++;
        this.y++
        break;
    }
  }
}